import { AppButton } from 'components';
import TablePaginate from 'components/Paginate';
import useChapterTopics from 'hooks/API/GET/useChapterTopics';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { INITIAL_PAGE, LIMIT } from 'utilities/constants';
import AddTopicModal from './AddTopicModal';

function MainTopics() {
  const [openTModal, toggleTModal] = useState(false);
  const { classID, subjectID, chapterID } = useParams();
  const [params, setParams] = useState({ page: INITIAL_PAGE, limit: LIMIT });

  const { data, isLoading, isError } = useChapterTopics({
    enabled: true,
    classID,
    subjectID,
    chapterID,
  });

  const { meta: { page, total, esPath, classPath, chapterPath, subjectPath } = {}, result = [] } =
    data?.data ?? {};

  return (
    <>
      <AddTopicModal open={openTModal} closeModal={() => toggleTModal(false)} />
      <div className="mainWraper">
        <div className="container-fluid outerborder">
          <div className="row">
            <div className="col-6">
              <h2 className="prime-head p-0">Manage topics</h2>
              <nav aria-label="breadcrumb">
                <span className="badge badge-primary"> + {esPath?.name}</span> /{' '}
                <span className="badge badge-light">{classPath?.name}</span> /{' '}
                <span className="badge badge-light">{chapterPath?.name}</span> /{' '}
                <span className="badge badge-light">{subjectPath?.name}</span>
              </nav>
            </div>
            <div className="col-6 prime-head text-right">
              <AppButton variantClass="btn-plane g--tint" onClick={() => toggleTModal(true)}>
                + Add topic
              </AppButton>
              <Link to={`/manage/classes/${classID}/chapters`}>
                <AppButton variantClass="btn-plane p--tint mx-2">&#8701; Back</AppButton>
              </Link>
            </div>
            <div className="col-6 prime-head text-right"></div>
          </div>

          <hr />
          {isLoading ? (
            'Loading...'
          ) : isError ? (
            'Failed to load data'
          ) : (
            <>
              {result?.length > 0 ? (
                <>
                  <div className="row">
                    {result?.map((result) => {
                      return (
                        <Link
                          key={result._id}
                          to={`/manage/classes/${classID}/subjects/${subjectID}/chapters/${chapterID}/topics/${result._id}`}
                        >
                          <div className="col-sm-3">
                            <div className="card" style={{ width: '18rem' }}>
                              <div className="card-body">
                                <h5 className="card-title">{result.name}</h5>
                                <h6 className="card-subtitle mb-2 text-muted">
                                  Status: {result.status}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </>
              ) : (
                'No records found'
              )}
            </>
          )}

          <div>
            <TablePaginate
              maxCount={total}
              currentPage={page}
              defaultLimit={params.limit}
              setPage={(page) => setParams((x) => ({ ...x, page }))}
              handleChange={(limit) => setParams((x) => ({ ...x, limit }))}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default MainTopics;
